import {FC} from 'react'
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {AuthPage, Logout, useAuth} from '../modules/auth'
import {App} from '../App'
import {AdminRoutes} from "./AdminRoutes";
import {URL_MAIN} from "../mock/page_urls";

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()

  return (
      <BrowserRouter>
        <Routes>
          <Route element={<App/>}>
            <Route path='error/*' element={<ErrorsPage/>}/>
            <Route path='logout' element={<Logout/>}/>
            {currentUser?.role === "SUPER_ADMIN" || currentUser?.role ===  "ADMIN" ? (
                <>
                  <Route path='/*' element={<AdminRoutes/>}/>
                  <Route index element={<Navigate to={URL_MAIN}/>}/>
                </>
            ) : (
                <>
                  <Route path='auth/*' element={<AuthPage/>}/>
                  <Route path='*' element={<Navigate to='/auth'/>}/>
                </>
            )}
          </Route>
        </Routes>
      </BrowserRouter>
  )
}

export {AppRoutes}
